import { TrackingForm } from "@/components/site/TrackingForm";

export default function Track() {
  return (
    <section className="relative grain overflow-hidden min-h-[70vh] flex items-center" data-testid="track-page">
      <img src="/images/loading.jpg" alt="" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-black/85" />
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-24 w-full">
        <p className="rise text-xs font-semibold uppercase tracking-[0.3em] text-[#E50914]">Traccia spedizione</p>
        <h1 className="rise rise-1 mt-4 font-display font-black uppercase tracking-tight leading-none text-4xl sm:text-5xl lg:text-6xl text-white">Dov'è la mia spedizione?</h1>
        <p className="rise rise-2 mt-5 text-slate-300">Inserisci il codice di tracciamento ricevuto (es. LGT47563846). Non è necessaria alcuna registrazione.</p>
        <div className="rise rise-3 mt-10">
          <TrackingForm size="hero" testPrefix="track-page" />
        </div>
      </div>
    </section>
  );
}
